import swal from "sweetalert2";
<template>
  <div class="content">
    <div class="row">
      <div class="col-md-6">
        <ArtistSelect
          @memberChangeEvent="getArtistInfo"
          :is-filter="true"
          :include-unit-artist="true"
          :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
        />
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">타입</h4>
        <div class="row">
          <el-select @change="getData" class="select-primary col-md-12" size="large" placeholder="선택" v-model="siteId">
            <el-option v-for="option in sites" class="select-primary" :value="option.siteId" :label="option.siteName" :key="option.siteName" />
          </el-select>
        </div>
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">노출</h4>
        <div class="row">
          <el-select @change="getData" class="select-primary col-md-12" size="large" placeholder="선택" v-model="visible.isVisible">
            <el-option v-for="option in visible.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h4 class="card-title text-left">기간</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-date-picker type="daterange" start-placeholder="검색 시작일" end-placeholder="검색 종료일" v-model="searchPeriod" />
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">구분</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select class="select-primary" size="large" placeholder="선택" v-model="searchType.type">
              <el-option v-for="option in searchType.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">검색어</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="검색어" v-model="searchWord">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left" />
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getData()" type="default">검색</base-button>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">필터</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select @change="getData" class="select-primary" size="large" placeholder="순서" v-model="order.order">
              <el-option v-for="option in order.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left" />
        <div class="row">
          <div class="col-md-4 text-left">
            <base-button @click="hideContents()" type="danger">선택숨김</base-button>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <h4 class="card-title text-left"></h4>
        <base-radio name="card" inline v-model="viewType">카드</base-radio>
        <base-radio name="list" inline v-model="viewType">리스트</base-radio>
      </div>
    </div>
    <div class="row" v-if="viewType == 'card'">
      <div class="col-md-3" v-for="item in list" :key="item.contentId">
        <card class="card">
          <iframe width="0" height="0" v-bind:src="item.iframeUrl" style="display: none"></iframe>
          <div>
            <base-checkbox v-model="item.isChecked"></base-checkbox>
          </div>
          <div v-if="item.media.length > 0">
            <img :src="item.media[0]" />
          </div>
          <div class="cover-img-area">[{{ item.contentId }}] {{ item.title | truncate(80) }}</div>
          <div class="source">{{ item.siteName }} ({{ item.description }})</div>
          <div class="regTime">{{ item.regTime | formatDateTime }}</div>
          <div class="stats">
            <span>{{ item.viewCount }} 뷰 / </span>
            <span>{{ item.likeCount }} Likes / </span>
            <span>{{ item.pinCount }} Pins / </span>
            <span>{{ item.commentCount }} 댓글/</span>
          </div>
          <base-button class="default" @click.prevent="showLink(item.path)">링크</base-button>
          <base-button class="default" @click.prevent="goDetail(item.contentId)">상세</base-button>
          <base-button v-if="item.isVisible != 0" class="btn-danger col-12" @click="hideContent(item.contentId)" type="success">숨김</base-button>

          <base-button v-if="item.isVisible != 1" class="footer-buttons col-12" @click="showContent(item.contentId)" type="success">표시</base-button>
          <base-button v-if="order.order === 2" class="footer-buttons col-12" @click="deleteHotContent(item.contentId)" type="danger">인기제거</base-button>
        </card>
      </div>
    </div>
    <div class="row" v-if="viewType == 'list'">
      <div class="col-md-12" v-for="item in list" :key="item.contentId">
        <div class="row">
          <div class="col-md-1">
            <base-checkbox v-model="item.isChecked"></base-checkbox>
          </div>
          <div class="col-md-6">[{{ item.contentId }}] {{ item.title | truncate(80) }} ({{ item.regTime }})</div>
          <div class="col-md-4">
            <base-button class="default" @click.prevent="showLink(item.path)">링크</base-button>
            <base-button class="default" @click.prevent="goDetail(item.contentId)">상세</base-button>
            <base-button v-if="item.isVisible != 0" class="btn-danger col-2" @click="hideContent(item.contentId)" type="success">숨김</base-button>

            <base-button v-if="item.isVisible != 1" class="footer-buttons col-2" @click="showContent(item.contentId)" type="success">표시</base-button>
            <base-button v-if="order.order === 2" class="footer-buttons col-2" @click="deleteHotContent(item.contentId)" type="danger">인기제거</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Card, BaseInput, BasePagination } from "@/components/index";
import moment from "moment";
import { URLUtils } from "@/util/URLUtils";
import swal from "sweetalert2";
import { UserData } from "@/util/UserData";
import _ from "lodash";

export default {
  components: {
    ArtistSelect,
    Card,
    BaseInput,
    BasePagination,
  },

  async created() {
    this.viewType = UserData.get("currentViewType") ?? "card";
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.searchType) {
        this.searchType.type = parseInt(this.$route.query.searchType);
      }
      if (this.$route.query.searchWord) {
        this.searchWord = this.$route.query.searchWord;
      }
      if (this.$route.query.siteId) {
        this.siteId = parseInt(this.$route.query.siteId);
      }
      if (this.$route.query.order) {
        this.order.order = parseInt(this.$route.query.order);
      }
      if (this.$route.query.isVisible) {
        this.visible.isVisible = parseInt(this.$route.query.isVisible);
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.searchPeriod = [moment(this.$route.query.startDate, "YYYY-MM-DD").toDate(), moment(this.$route.query.endDate, "YYYY-MM-DD").toDate()];
      }
    }
    await this.getSites();
  },
  data() {
    return {
      sites: [],
      searchWord: null,
      searchType: {
        type: 1,
        options: [
          { label: "제목", value: 1 },
          { label: "내용", value: 2 },
          { label: "링크", value: 3 },
        ],
      },
      visible: {
        isVisible: 1,
        options: [
          // { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      searchPeriod: [],
      list: [],
      siteId: null,
      unitId: null,
      memberId: null,
      lastId: 0,
      currentPage: 1,
      totalPages: null,
      viewType: "card",
      order: {
        order: 1,
        options: [
          { label: "최신순", value: 1 },
          { label: "인기순", value: 2 },
        ],
      },
    };
  },
  watch: {
    viewType: {
      handler() {
        UserData.set("currentViewType", this.viewType);
      },
    },
    currentPage: {
      handler() {
        this.getData(this.currentPage);
      },
    },
  },
  methods: {
    async getSites() {
      return this.$axios.get("/radarContent/sites").then((res) => {
        this.sites = res.data.data;
        this.sites.unshift({ siteId: null, siteName: "전체" });
      });
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getData();
    },
    async getData(page) {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
        isVisible: this.visible.isVisible ?? undefined,
      };
      const params = { unitId: this.unitId, memberId: this.memberId, isVisible: this.visible.isVisible };
      if (this.searchPeriod) {
        queryParams.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString(true) : undefined;
        queryParams.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString(true) : undefined;
        params.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString() : undefined;
        params.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString() : undefined;
      }
      queryParams.searchWord = this.searchWord;
      queryParams.searchType = this.searchType.type;
      queryParams.siteId = this.siteId;
      queryParams.order = this.order.order;
      params.siteId = this.siteId;
      params.order = this.order.order;
      params.currentPage = page ? page : 1;

      if (this.searchWord !== "" && this.searchWord != null) {
        if (this.searchWord) {
          if (this.searchType.type === 1) {
            params.title = this.searchWord;
          } else if (this.searchType.type === 2) {
            params.content = this.searchWord;
          } else if (this.searchType.type === 3) {
            params.path = this.searchWord;
          }
        }
      }

      const path = `/radars/radarContents?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) this.$router.push(path);

      const url = params.order === 1 ? `/radarContent` : `/radarContent/hot`;

      return this.$axios.get(url, { params }).then((res) => {
        this.list = res.data.data.data;
        this.totalPages = Number(res.data.data.page);
        const temps = [];
        for (let i = 0; i < this.list.length; i++) {
          const media = this.list[i].media;
          if (media.length > 0) {
            this.list[i].iframeUrl = `${window.Endpoints.iframeUrl}${encodeURIComponent(media[0])}`;
          }
          temps.push(this.list[i].media);
          this.list[i].media = [];
        }
        const me = this;
        setTimeout(function () {
          for (let i = 0; i < me.list.length; i++) {
            me.list[i].media = temps[i];
          }
        }, 500);
        if (this.list.length > 0) {
          this.lastId = this.list[this.list.length - 1].contentId;
        } else {
          this.lastId = 0;
        }
      });
    },
    goDetail(contentId) {
      this.$router.push(`/radars/radarContentDetail?unitId=${this.unitId}&contentId=${contentId}`);
    },
    async hideContent(contentId) {
      swal
        .fire({
          title: "숨김 확인",
          text: `${contentId} 컨텐트를 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/radarContent/${contentId}/state`, {
                  params: { unitId: this.unitId, isVisible: 0 },
                })
                .then(() => {
                  window.Toast.success("컨텐트가 숨김 되었습니다");
                  this.list.forEach((item) => {
                    if (item.contentId === contentId) {
                      item.isVisible = 0;
                    }
                  });
                  // this.getData();
                });
            } catch (err) {
              window.Toast.error("컨텐트 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async hideContents() {
      swal
        .fire({
          title: "숨김 확인",
          text: `선택된 컨텐츠를 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            const contentIds = this.list
              .filter((item) => item.isChecked)
              .map((item) => {
                return item.contentId;
              });
            if (contentIds.length === 0) {
              window.Toast.error("선택된 컨텐츠가 없습니다");
              return;
            }
            try {
              return this.$axios
                .put(`/radarContent/hideContents`, {
                  params: { contentIds },
                })
                .then(() => {
                  window.Toast.success("컨텐츠가 숨김 되었습니다");
                  this.list.forEach((item) => {
                    item.isChecked = false;
                    if (contentIds.includes(item.contentId)) {
                      item.isVisible = 0;
                    }
                  });
                });
            } catch (err) {
              window.Toast.error("컨텐트 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async showContent(contentId) {
      swal
        .fire({
          title: "표시 확인",
          text: `${contentId} 컨텐트를 표시하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "표시",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/radarContent/${contentId}/state`, {
                  params: { unitId: this.unitId, isVisible: 1 },
                })
                .then(() => {
                  window.Toast.success("컨텐트가 표시 되었습니다");
                  this.getData();
                });
            } catch (err) {
              window.Toast.error("컨텐트 표시 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async deleteHotContent(contentId) {
      swal
        .fire({
          title: "인기게시물 삭제 확인",
          text: `${contentId} 컨텐트를 인기게시물에서 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios.delete(`/radarContent/${contentId}/hotContent`).then(() => {
                window.Toast.success("인기게시물이 삭제 되었습니다");
                this.getData();
              });
            } catch (err) {
              window.Toast.error("인기게시물이 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    showLink(link) {
      window.open(link);
    },
  },
};
</script>
<style scoped>
img {
  height: 100px;
}
button {
  margin-top: 20px;
}
</style>
